import React from "react";
import { Link } from "react-router-dom";
import ProjectTools from "./ProjectTools";

export default props => (
  <section className="col-3 col-6-medium col-12-xsmall">
    <div className="col">
      <span className="image fit project-image">
        <img
          src={
            props.image ||
            "https://images.unsplash.com/photo-1541233349642-6e425fe6190e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&w=1000&q=80"
          }
          alt="saasa"
        />
      </span>
    </div>

    <Link
      to={{
        pathname: `project/${props.id}`,
        state: {
          id: props.id
        }
      }}
    >
      <h3 className={"project-title"}> {props.name || "Project Name"}</h3>
    </Link>
    <a target="_blank" href={props.link}>
      live site
    </a>
    <p className={"text-left"}>
      {props.description ||
        "An Application that allows using to communicate best prices for products they find."}
    </p>
    {/*  Project tools  */}
    <ProjectTools />
  </section>
);
